export const getSortByObjectKey = (array, key) => {
  // Sort the combined events by time
  const sortedArray = array?.sort((a, b) => {
    return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
  });
  return sortedArray;
};
